import paymentApi from '../../utils/paymentApi';

function unwrap(response) {
  const body = response?.data;
  if (Number(body?.code) === 401) {
    localStorage.removeItem('token');
    window.location.assign('/login');
    throw new Error(body?.message || '登录状态已失效，请重新登录');
  }
  if (Number(body?.code) !== 200) {
    const error = new Error(body?.message || '请求失败');
    error.code = body?.data?.error_code || body?.code;
    error.data = body?.data;
    throw error;
  }
  return body.data || {};
}

function normalizeError(error) {
  if (error?.code && !error?.response) return error;
  const body = error?.response?.data;
  const normalized = new Error(body?.message || error?.message || '请求失败');
  normalized.code = body?.data?.error_code || body?.code || error?.code;
  normalized.data = body?.data;
  normalized.status = error?.response?.status;
  return normalized;
}

const request = promise => promise.then(unwrap).catch(error => { throw normalizeError(error); });

export const getCorporateBankAccounts = () => request(paymentApi.get('/corporate-finance/bank-accounts'));
export const getBankTransfers = params => request(paymentApi.get('/corporate-finance/transfers', { params }));
export const createBankTransfer = data => request(paymentApi.post('/corporate-finance/transfers/create', data));
export const cancelBankTransfer = id => request(paymentApi.post('/corporate-finance/transfers/cancel', { id }));
export const getInvoiceEligibleOrders = (scope, invoiceBasis = 'order') => request(paymentApi.get('/corporate-finance/invoices/eligible-orders', { params: { scope, invoice_basis: invoiceBasis } }));
export const getInvoices = params => request(paymentApi.get('/corporate-finance/invoices', { params }));
export const createInvoice = data => request(paymentApi.post('/corporate-finance/invoices/create', data));
export const getEnterpriseCertification = scope => request(paymentApi.get('/corporate-finance/enterprise-certification', { params: { scope } }));
export const getEnterpriseCertificationDocumentPreview = (scope, documentId) => request(paymentApi.get(
  '/corporate-finance/enterprise-certification/document-preview',
  { params: { scope, document_id: documentId } },
));
export const submitEnterpriseCertification = data => request(paymentApi.post('/corporate-finance/enterprise-certification/submit', data));
export const uploadEnterpriseCertificationDocument = (file, documentType) => {
  const data = new FormData();
  data.append('file', file);
  data.append('document_type', documentType);
  return request(paymentApi.post('/corporate-finance/enterprise-certification/document', data));
};
export const getPersonalCertification = () => request(paymentApi.get('/corporate-finance/personal-certification'));
export const getPersonalCertificationDocumentPreview = documentId => request(paymentApi.get(
  '/corporate-finance/personal-certification/document-preview',
  { params: { document_id: documentId } },
));
export const submitPersonalCertification = data => request(paymentApi.post('/corporate-finance/personal-certification/submit', data));
export const uploadPersonalCertificationDocument = (file, documentType) => {
  const data = new FormData();
  data.append('file', file);
  data.append('document_type', documentType);
  return request(paymentApi.post('/corporate-finance/personal-certification/document', data));
};
export const getFinanceCreditPackages = planType => request(paymentApi.get('/credit-package/list', { params: { plan_type: planType } }));
export const uploadFinanceFile = file => {
  const data = new FormData();
  data.append('file', file);
  return request(paymentApi.post('/media/upload', data, { headers: { 'Content-Type': 'multipart/form-data' }}));
};
